import Configs from '../../../src/vendorConfigs/Configs';
import IBuyFeatureData from '../server/data/IBuyFeatureData';
import { BaseModel } from "./BaseModel";
class BuyFeatureModel extends BaseModel<IBuyFeatureData> {
    public buyFeature: boolean = false;
    public hasBuyFeatureIsTriggered: boolean = false;
    public isInBuyFeatureFreeSpins: boolean = false;
    public validBets: number[] = [];
    public currentBetIndex: number = 0;
    public mode: number = 0;
    public extraParams: any[] = [];
    public isActivated: boolean = false;
    public getBet(): number {
        return this.validBets[this.currentBetIndex]
    }
    public getTotalBet = (index?: number) => {
        let config = Configs.buyFeature;
        let currentBet = this.validBets[index || this.currentBetIndex];
        return config.betMultiplier[this.mode] * currentBet
    }
}

export default new BuyFeatureModel()
